
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { ApiService } from '../../../shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss']
})
export class BookingComponent implements OnInit {
  sub: Subscription = new Subscription();
  productId: any;
  minDate: any;
  maxDate: any;
  productDetailList: any;
  changedbookingAmount: any;
  tabValue: any = '';
  quantity: any;
  totalAmount: any;
  breadcrumbdata: any = [];
  showBreadCrumb: boolean = false;
  hideSelection: boolean = false;
  environment1 = environment.s3bucket.url;

  productLoaded: boolean = false
  breadcrumbList: { label: any; url: string; pageName: string; };
  VasData: any;
  isVasAvailable: any = false;
  typeOfBooking: string;
  vc: any;
  newVCPrice: any;
  typeOfBookingFni: string;
  row_idfnijourney: string;
  isfnijourney: boolean = false;
  payment_data: any = [];
  schemeDealeCodes = ['1009590','1009460', '1001850','100B780','1007960','1009061','1001770','1009050','1009000','1000480','1008870', '1002600','100B710','100A150','1004850','100B540','1003530']

  schemeDetailList: any;
  loyalityborder: boolean = false;
  currentRoute: any;
  constructor(
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private localStorage: secureStorage,
    private datePipe: DatePipe,
    private behaviourSubject: BehaviourSubjectService,
    @Inject(PLATFORM_ID) private platformId: Object,private router: Router,
  ) { }
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('rewardTermsCondition');
      localStorage.removeItem('currentRoute');
      localStorage.removeItem('schemeCode');
    }
    this.currentRoute = this.router.url;

    this.sub.add(this.activatedRoute.queryParams.subscribe((params) => {
      if (params['dealer']) {
        if (isPlatformBrowser(this.platformId)) {

          localStorage.setItem("dealercd", params['dealer']);
          localStorage.setItem("vc", params['vc']);
          this.vc = params['vc']
        }
      }
      if (params['vc']) {

        this.getVehicleDetail();
      }

    }));
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.row_idfnijourney = params.get('row_id');
    });
    if (this.row_idfnijourney) {
      this.getleadData(this.row_idfnijourney)
      this.isfnijourney = true;
    }
    else {
      this.isfnijourney = false;
    }
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id') || params.get('type')) {
        this.typeOfBooking = params.get('type');
        this.typeOfBookingFni = params.get('type');
        this.productId = params.get('id');
        this.getVehicleDetail();
      }
    })
    this.sub.add(this.behaviourSubject.vasCreated.subscribe(() => {
      if (this.typeOfBooking == 'Finance') {
        this.VasData = this.localStorage.getItem("VASDataProfile") ? JSON.parse(this.localStorage.getItem("VASDataProfile")) : null;
      }
      else {
        this.VasData = this.localStorage.getItem("VASData") ? JSON.parse(this.localStorage.getItem("VASData")) : null;

      }
      this.isVasAvailable = this.VasData?.VasAvailable == 'YES' ? true : false;
    }));

      let dealercdforloyality = localStorage.getItem('dealercd');
      // this.loyalityborder = this.schemeDealeCodes.includes(dealercdforloyality) ? true : false
    
  }
  tabChange(event: any) {
    this.tabValue = event.target.value;
    localStorage.removeItem('schemeCode');
    this.getSchemeDetails(this.productDetailList.vehicle_number);
  }
  onQuantityChange(data: any) {
    this.quantity = data.quantity;
    this.totalAmount = data.totalAmount;
    this.changedbookingAmount = this.totalAmount <= this.productDetailList?.down_payment ? this.productDetailList?.down_payment : (this.totalAmount / data.quantity)
  }
  onVCPriceChange(data: any) {
    if (data.newVCPrice) {
      this.newVCPrice = data.newVCPrice
    } else {
      this.newVCPrice = null;
    }
  }
  ondealerDataChange(data: any) {
    if (data?.dealerDataList) {
      this.maxDate = data?.dealerDataList["Tentative_Arrival_Date__TAD____Max"]
      this.minDate = data?.dealerDataList["Tentative_Arrival_Date__TAD____Min"]
      let tempMaxDat = this.maxDate.split('-')
      this.maxDate = tempMaxDat[2] + '-' + tempMaxDat[1] + '-' + tempMaxDat[0]
      let tempMinDat = this.minDate.split('-')
      this.minDate = tempMinDat[2] + '-' + tempMinDat[1] + '-' + tempMinDat[0]
      const mindate = new Date(+tempMinDat[0], +tempMinDat[1] - 1, +tempMinDat[2]);
      const maxdate = new Date(+tempMaxDat[0], +tempMaxDat[1] - 1, +tempMaxDat[2]);
      this.maxDate = this.datePipe.transform(maxdate, 'dd MMM yyyy', "en-GB")
      this.minDate = this.datePipe.transform(mindate, 'dd MMM yyyy', "en-GB")
    } else {
      this.minDate = null;
      this.maxDate = null;
    }
  }

  getVehicleDetail() {
    let data;
    if (this.vc) {
      data = {
        vehicle_number: this.vc
      }
    }
    else {
      data = {
        product_id: this.productId
      }
    }
    this.sub.add(this.apiService.getVehicleDetails(data).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.productDetailList = res?.data;
          // uncomment later
          if (this.VasData && (this.VasData.VCNUMBER !== this.productDetailList.vehicle_number)) {
            localStorage.removeItem('VASData');
            this.behaviourSubject.vasCreated.next(true);
          }
          this.totalAmount = this.productDetailList?.down_payment
          this.productLoaded = true
          if (this.productDetailList.sub_lob !== 'SCV Pickups' || this.typeOfBooking == 'Finance') {
            // this.tabValue = 'have-finance';
            this.tabValue = 'need-finance';
            this.hideSelection = true;
          } else {
            if (this.VasData?.SubLob == 'scv-pickups' && this.VasData?.openPage == 'booking') {
              this.tabValue = 'have-finance';
              this.hideSelection = false;
            } else if (this.VasData?.SubLob == 'scv-pickups' && this.VasData?.openPage == 'finance') {
              this.tabValue = 'need-finance';
              this.hideSelection = false;
            } else {
              this.tabValue = 'need-finance';
              this.hideSelection = false;
            }
          }
          this.breadcrumb();
          if (this.productDetailList.vehicle_number) {
            this.getSchemeDetails(this.productDetailList.vehicle_number);
          }
        }
      },
      error: () => { this.productLoaded = true },
      complete: () => { }
    }))
  }

  getFinalAmt(vas, totalAmount) {
    return vas?.VASBookingAmount ? Number(vas?.VASBookingAmount) + Number(totalAmount) : 0 + totalAmount;
  }
  breadcrumb() {

    localStorage.removeItem("ExploreMappedData")
    localStorage.removeItem("ExploreMappedData1")
    localStorage.removeItem('ExploreMappedDatatype')
    localStorage.removeItem('ExploreMappedDatamodal')
    localStorage.removeItem("explore")
    localStorage.removeItem("EModeldData")
    localStorage.removeItem('localBreadCrumb');
    localStorage.removeItem("exploreData")
    localStorage.removeItem("UrlData")
    this.breadcrumbList = {
      label: this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'Trucks' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'buses' ? 'Buses & Vans' : this.productDetailList.sub_lob,
      url: `/product-list/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()),
      pageName: 'product-details',
    };

    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: this.productDetailList.lob,
      url: `/category-list/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productDetailList.lob?.replace(/\s/g, "-")?.toLowerCase(),
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: this.productDetailList.ppl,
      url: `/product-list/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productDetailList.lob?.replace(/\s/g, "-")?.toLowerCase() + `/` + this.productDetailList.ppl?.replace(/\s/g, "-").replace("---", "-")?.toLowerCase(),
      pageName: 'product-list',

    };
    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: this.productDetailList.model,
      url: `/product-details/` + (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailList.sub_lob.replace(/\s/g, "-")?.toLowerCase()) + `/` + this.productDetailList.lob.replace(/\s/g, '-')?.toLowerCase() +
        `/` + this.productDetailList.ppl.replace(/\s/g, '-').replace('---', '-')?.toLowerCase() +
        `/` + ((this.productDetailList.model.replace(/\//g, "-").replace(/\+/g, "-").replace(/\./g, "-")?.toLowerCase())) +
        `/` + this.productDetailList.id,
      pageName: 'product-details',
    };
    this.breadcrumbdata.push(this.breadcrumbList);
    this.breadcrumbList = {
      label: 'book now',
      url: '',
      pageName: 'booking',
    };
    this.breadcrumbdata.push(this.breadcrumbList);

    this.localStorage.setItem(
      'localBreadCrumb',
      JSON.stringify(this.breadcrumbdata)
    );

    this.showBreadCrumb = true;

  }
  getleadData(data: any) {
    let payload = {
      "action_type": "payment_data",
      "row_id": data
    }
    // this.spi.show();
    this.sub.add(this.apiService.getLeadsnew(payload).subscribe({
      next: (res) => {
        if (res.success) {
          this.payment_data = res?.data?.payment_data

          // this.spinner.hide();
        }
        else {
          this.payment_data = [];
          // this.toastrService.warning(res.data.msg);
          // this.spinner.hide();
        }
      },
      error: (err) => {
      }, complete: () => { }
    }));
  }
  getSchemeDetails(vc: string) {
    try {
      let data = { vc, "visibility": "web" };

      this.sub.add(
        this.apiService.getSchemeDetails(data).subscribe({
          next: (res: any) => {
            if (isPlatformBrowser(this.platformId)) {
              if (res?.data) {
                if (this.tabValue == 'need-finance') {
                  const matchingScheme = res.data.find((booking: any) =>
                    booking?.scheme_master?.parameter === "Online booking with finance"
                  );
                  if (matchingScheme) {
                    this.schemeDetailList = matchingScheme;
                    localStorage.setItem('schemeDetails', JSON.stringify(this.schemeDetailList.scheme_master?.scheme_value));
                    localStorage.setItem('schemeCode', this.schemeDetailList?.scheme_code);
                  }else{
                    this.schemeDetailList = []}

                } else if (this.tabValue == 'have-finance') {
                  const matchingScheme = res.data.find((booking: any) =>
                    booking?.scheme_master?.parameter === "Online booking without finance"
                  );
                  if (matchingScheme) {
                    this.schemeDetailList = matchingScheme;
                    localStorage.setItem('schemeDetails', JSON.stringify(this.schemeDetailList.scheme_master?.scheme_value));
                    localStorage.setItem('schemeCode', this.schemeDetailList?.scheme_code);
                  }
                  else{
                    this.schemeDetailList = []}

                } else {
                  this.schemeDetailList = []
                }


              } else {

              }
            }
          },
          error: (err) => {

          },
          complete: () => {

          }
        })
      );

    } catch (error) {

    }
  }

  gotorewardtermscondition(row: any){
    const data = row.scheme_master;
this.localStorage.setItem('rewardTermsCondition', JSON.stringify(data));
this.localStorage.setItem('currentRoute', this.currentRoute);

  this.router.navigate(['/reward-terms-condition'],{queryParams: {id:this.productId,isBooking:true}})
}

}

